module.exports = __webpack_public_path__ + "img/Warrior-troll-m-70.6c56b499.gif";